export default from './time-ago';



// WEBPACK FOOTER //
// ./app/components/time-ago/index.js